import { useSessionUser } from '@/hooks/use-session'
import type { EmployerEntry } from 'shared/types'

const DANCHIANO_ENTRY: EmployerEntry = {
  companyId: null,
  name: "D'Anchiano",
  image: null,
  employeeType: null,
  reevaluate: null,
}

// Active employer for a multi-company employee; the choice lives in the session, so the switcher is global.
export function useActiveEmployer() {
  const user = useSessionUser()
  const isEmployee = user?.type === 'applicant' && user.isEmployee

  // Rides the session, so the list and the active row below always come from the same answer.
  const companyEmployers: EmployerEntry[] = user?.employers ?? []
  const list: EmployerEntry[] = companyEmployers.length > 0 ? [DANCHIANO_ENTRY, ...companyEmployers] : []
  // From getUser, so the chrome renders atomically with the user; null means the personal profile.
  const activeEmployer = user?.activeEmployer ?? list[0]
  const activeEmployerId = activeEmployer?.companyId ?? null

  return { employers: list, activeEmployer, activeEmployerId, isEmployee }
}
